import 'antd/dist/reset.css'
import React, { FC } from 'react'

import 'styles/customize.antd.css'
import 'styles/table.css'

import AppRoutes from './AppRoutes'

const App: FC = () => {
  return <AppRoutes />
}

export default App
